export default {
  // 部门
  dept: {
    dept: '部门',
    AddSubDepartment: '添加子部门',
    EditDepartment: '编辑部门',
    AddDepartment: '添加部门',
    deptName: '部门名称',
    parentDept: '上级部门',
    PersonDept: '部门负责人',
    deptId: '部门ID',
    Employee: '员工',
    AddEmployee: '添加员工',
    ResignaEmployee: '离职员工',
    ImportEmployee: '导入员工',
    ExportEmployee: '导出员工',
    Exportrecords: '导出账户升级记录',
    deptEmployee: '员工与部门',
    DepartmentTip: '如何使用员工与部门',
    delDept: '是否删除该部门',
    updateDept: '变更部门',
  },
  // 角色
  role: {
    AbnormalTip: '该员工缺少角色权限，无法进行系统操作',
    AbnormalTip2: '该员工缺少数据范围，无法进行系统操作',
    AbnormalTip3: '该员工缺少角色权限和数据范围，无法进行系统操作',
    NormalTip: '正常角色',
    DisabledTip: '禁用角色',
    brand: '品牌',
    brandAdmin: '品牌管理员',
    brandStaff: '品牌员工',
    shopAdmin: '门店管理员',
    shopStaff: '门店员工',
    roles: '角色',
    roleId: '身份',
    role: '总部角色',
    addRole: '添加角色',
    editRole: '编辑角色',
    MemberAdmin: '成员账号',
    Permission: '角色权限',
    roleTip: '如何使用员工与角色',
    name: '姓名',
    phone: '手机号',
    data: '数据范围',
    roleInfo: '角色信息',
    roleInfoTip: '设置角色名称等信息',
    PermissionTip: '设置角色可以管理权限范围',
    editPermission: '编辑权限',
    delTip: '是否删除该角色！',

    remark: '角色说明',
    roleKey: '角色类型',
    remarkTip: '请输入说明，让其他管理员了解此角色的用途和注意事项',
    roleName: '角色名称',
    roleNameTip: '不建议角色名称前加品牌名称，避免角色列表展示杂乱、重要信息被截断',
    clientType_1: '品牌管理平台',
    clientType_2: '门店助手APP',
    clientType_3: '桌面收银台',
    clientType_4: '移动POS机',
  },
  // 菜单
  mune: {
    Permission: '菜单权限',
    OperaPermis: '操作权限',
    editPermission: '编辑权限',
    SelectAll: '全选',
    oppositionalVoting: '取消选中',
  },
  user: {
    nickName: '姓名',
    account: '账号',
    email: '邮箱',
    password: '密码',
    phonenumber: '手机号',
    accountType: '账号类型',
    remark: '备注',
    sex: '性别',
    dataTip: '控制员工账号可以访问哪些的门店、仓配中心、加工间等业务组织数据，支持动态范围、固定范围两种设置类型。',
    addData: '添加数据范围',
    roleTip: '选择角色后，员工将获得角色拥有的运营后台相关功能的操作权限',
    add: '新增员工',
    bindEmployee: '绑定员工',
    bindSuccess: '绑定成功',
    edit: '编辑员工',
    delUserTip: '是否删除该员工！',
    statusP: '是否启用该员工！',
    statusD: '是否禁用该员工！',
    SelectStoreGroup: '选择门店组',
    SelectStore: '选择门店',
    SelectBrand: '选择品牌',
    Normal: '正常',
    Disabled: '停用',
    userRoledel: '移除',
    callingCode: '地区码',
    Abnormal: '异常',
    userRoledelTip: '是否将该员工从当前角色移除！',
    userShopdelTip: '是否将该员工从门店员工中移除！',
    suerTip1: '当前门店已有门店管理员，添加账号为员工账号',
    suerTip2: '当前门店无门店管理员，添加账号为门店管理员账号',
    Account: '账户',
    addUser: '添加成员',
    addUserTip: '员工赋予角色后，员工将获得角色拥有的运营后台相关功能的操作权限 ',
    userRole: '员工权限',
    storeRole: '按门店角色选择',
    permission: '按权限点选择',
    Employee: '选择员工门店',
    Information: '员工基本信息',
    RoleInformation: '员工角色信息',
    addAdmin: '添加门店管理员',
    userAdminTip: '门店还未添加门店管理员，为了方便门店管理，请尽快添加门店管理员',
    userAdminTip2: '门店管理员可以自主管理门店员工账号',
  },
  // 门店管理
  shop: {
    shop: '门店',
    StoreManag: '门店管理',
    StoreManagTip: '门店基础信息、营业信息以及全生命周期管理',
    shopTypeTip: '门店正式开业，将扣减门店席位',
    TopSortState: '此操作会将门店',
    TopSortEnd: '置顶, 是否继续?',
    addShopGroup: '新增门店组',
    editShopGroup: '编辑门店组',
    addShop: '新增门店',
    editShop: '编辑门店',
    updateShopGroup: '更改门店组',
    GroupName: '门店组',
    parentGroup: '上级门店组',
    PersonGroup: '门店组负责人',
    partmentGroup: '添加子门店组',
    BusinesShop: '营业门店',
    PreparingShop: '筹备门店',
    ClosedShop: '停业门店',
    shopGroup: '门店组',
    shopTags: '门店标签',
    shopName: '门店名称',
    shopCode: '门店编码',
    areaAddress: '门店地址',
    openStatus: '营业状态',
    shopStatus: '门店状态',
    shopGroupName: '门店组名称',
    shopGroupTip: '门店组不能与上级门店组相同',
    shopCount: '门店组门店数',
    shopGroupId: '门店组ID',
    shopGroupDel: '是否删除该门店组？',
    shopDel: '是否删除该门店？',
    GroupZi: '添加子门店组',
    Ungrouped: '未分组',
    shopSet: '经营信息',
    shopinfo: '基本信息',
    shopZ: '门店账号',
    shopInfo: '门店基本信息',
    shopAdmin: '门店管理员',
    shortName: '门店简称',
    brief: '门店简介',
    are: '省/市/区',
    Address: '详细地址',
    Replace: '更换',
    shopReplace: '变更门店管理员',
    newUserAdminName: '新管理员姓名',
    newEmail: '新管理员邮箱',
    newphonenumber: '新管理员电话',
    newRole: '新管理员角色',
    oldAdminRole: '员工角色',
    oldAdmin: '原管理员',
    downgrade: '降为员工',
    shopStutas_1: '创建门店',
    shopStutas_2: '计划开业',
    shopStutas_3: '取消计划开业',
    shopStutas_4: '正式开业',
    shopStutas_5: '暂停营业',
    shopStutas_6: '恢复营业',
    shopStutas_7: '永久关停',
    shopStutas_8: '立即开业',
    shopStutas_9: '开业中',
    shopStutas_10: '待开业',
    shopPreparingShop: '保存为筹备门店',
    shopUpdataTime_1: '创建时间',
    shopUpdataTime_2: '计划开业时间',
    shopUpdataTime_3: '取消计划开业时间',
    shopUpdataTime_4: '正式开业时间',
    shopUpdataTime_5: '暂停营业时间',
    shopUpdataTime_6: '恢复营业时间',
    shopUpdataTime_7: '永久关停时间',
    shopMessage_1: '该门店是否取消计划开业！',
    shopMessage_2: '该门店是否恢复营业！',
    StoreNotice: '门店公告',
    StoreNoticeTip: '门店公告用于小程序端显示，最多5条,每条最多25个中文字符',
    addSpecialDate: '新增特殊日期',
    editSpecialDate: '特殊日期设置',
    addbusiness: '新增营业时间',
    editbusiness: '营业时间设置',
    businessTip: ' 每个营业日工作时段',
    shopweek: '门店生命周期',
    suspension: '暂停原因',
    cor_shopName: '确定停业请输入门店名称',
    CloseStore_1: '停业后，门店将永久关闭，不能重新开业',
    CloseStore_2: '停业后，门店已用的服务席位 (如门店服务的续期次数) 不会被返还',
    CloseStore_3: '停业后，门店关联的 POS 和排队取餐业务也将停用，同时席位不会被返还',
    CloseStore_4: '停业后，门店内所有账号将被删除，总部账号内数据范围也会删除此门店',
    CloseStore_5: '停业后，门店扩展信息内数据将会被清空',
    CloseStore_6: '门店在计划时间点将自动开业，同时扣减门店席位',
    CloseStore_7: '已计划开业的门店会在小程序端门店列表展示，营造开业氛围',
    CloseStore_8: '暂停营业后，门店小程序将无法继续接受订单',
    CloseStore_9: '暂停营业后，门店POS业务将停用',
    CloseStore_10: '请正确输入门店名称',
    accountNum: '门店账号 （人）',
  },
  // 标签
  tags: {
    addtagsGroup: '新建分组',
    tagsName: '标签名称',
    shopNum: '关联门店数',
    tagsGroup: '标签房租',
    tagsType: '标签类型',
    addtags: '新增标签',
    edittags: '编辑标签',
    delTagsTip: '是否删除该标签',
  },
  // 门店员工  门店角色
  shopUserRole: {
    shopUser: '门店员工',
    shopRole: '门店角色',
    shopUserTip: ' 门店员工添加门店角色后即可登录使用自然源数店APP，请在门店详情页管理对应门店员工',
    AffiliatedStore: '所属门店',
  },
  decorate: {
    notice: '支持每个端口进行单独装修，也可一键将装修页面快速同步到其他端口。',
    miniProgram: '小程序',
    officialAccount: '公众号H5',
    enterDecoration: '进入装修',
    application: '应用',
    selectApplication: '请选择应用',
    refresh: '刷新',
    resetPage: '重置页面',
    resetPageConfirm: '确认重置页面吗？当前页面将恢复系统初始结构，未保存的修改将被覆盖；重置后仍需点击保存。',
    unsavedTitle: '当前修改尚未保存',
    unsavedMessage: '离开后，本次修改将不会保留。',
    continueEditing: '继续编辑',
    discardChanges: '放弃修改',
    exportPage: '导出页面',
    importPage: '导入页面',
    importPageConfirm: '请选择 JSON 格式的页面配置文件。文件格式校验通过后将覆盖当前页面内容，保存前可继续调整。',
    exportPageConfirm: '将导出当前页面的完整装修配置，导出操作不会修改当前页面内容或保存状态。',
    pageExported: '页面导出成功',
    pageImported: '页面导入成功',
    pageImportInvalid: '导入失败，文件格式错误',
    mallPages: '商城装修页面',
    pageListTitle: '页面',
    pageTotal: '共 {count} 个',
    systemPage: '系统页面',
    addTemplate: '新增模板',
    copyTemplate: '复制模板',
    templateName: '模板名称',
    templateLibrary: '模板库',
    templateLibraryTip: '模板由品牌系统统一初始化，内容为只读且不可编辑，当前页面仅支持预览。',
    templateLibrarySelectTip: '请选择与当前页面类型匹配的模板，选择后可基于模板内容继续装修。',
    chooseTemplate: '选择模板',
    applyTemplateTitle: '应用模板',
    applyTemplateConfirm: '确认将“{templateName}”应用到“{pageName}”吗？当前页面已有装修内容将被覆盖，保存前可继续调整。',
    templateSelected: '模板已加载，可继续装修后保存',
    templatePageMismatch: '模板页面类型与当前页面不匹配',
    allPages: '全部页面',
    noTemplates: '暂无模板',
    templateLoadFailed: '模板加载失败，请稍后重试',
    defaultTemplate: '默认模板',
    unnamedTemplate: '未命名模板',
    enterTemplateName: '请输入模板名称',
    templateCreated: '空白模板创建成功',
    home: '首页',
    mallCategory: '商城分类',
    userCenter: '个人中心',
    productDetail: '商品详情',
    page: '页面',
    preview: '预览',
    copy: '复制',
    skip: '跳过',
    decorate: '装修',
    rename: '改名',
    apply: '修改应用',
    delete: '删除',
    addPage: '添加装修页面',
    renamePage: '修改页面名称',
    enterPageName: '请输入页面名称',
    claimNow: '立即领取',
    channelComingSoon: '该端口的装修页面正在搭建中',
    demoApplication: '演示应用',
    mallApplication: '商城应用',
    enteredDecoration: '已进入装修模式',
    refreshed: '页面已刷新',
    enabled: '页面已启用',
    disabled: '页面已停用',
    templateActive: '生效中',
    templateInactive: '停用',
    switchTemplateConfirmTitle: '切换生效模板',
    switchTemplateConfirmMessage: '切换后将关闭当前生效模板，确定要将此模板设为生效吗？',
    deactivateTemplateConfirmTitle: '停用页面模板',
    deactivateTemplateConfirmMessage: '停用自定义页面模板后，该页面可暂时没有生效模板，模板内容将保留。确定要停用吗？',
    templateActivated: '模板已生效',
    templateDeactivated: '模板已停用',
    systemPageActiveRequired: '系统页面必须保留一个生效模板',
    applied: '已修改应用',
    renamed: '页面名称已修改',
    deleteTemplateConfirm: '确定要删除模板“{name}”吗？',
    templateDeleted: '模板已删除',
    templateCopied: '模板复制成功',
    deleted: '页面已删除',
    newPage: '全新页面',
    startDecoration: '开始装修',
    templateRegular: '装修模板 — 常规版',
    templateNewYear: '装修模板 — 新年狂欢',
    templateValentine: '装修模板 — 礼遇七夕',
    templateDark: '装修模板 — 酷帅简色',
    templateMarket: '装修模板 — 鲜活市集',
    templateFood: '装修模板 — 餐饮简版',
    templateTea: '装修模板 — 茶饮简版',
    templateMall: '商城页面',
    heroCarnival: '狂欢季',
    heroCoupon: '大额优惠券来袭',
    heroCongratulations: '恭喜获得优惠券',
    heroFifty: '50元',
    heroValentine: '相约七夕 为爱放价',
    heroDiscount: '多省10%',
    heroShorts: 'RC SHORT 系列',
    heroFreedom: '穿行自由',
    heroFreshMarket: '生鲜超市',
    heroTodayDeal: '今日特惠',
    heroFood: '暖心餐食',
    heroTryNew: '新品尝鲜',
    heroSummerTea: '夏日茶饮',
    heroNewTea: '清爽上新',
    heroMember: '会员专享',
    heroMallGoods: '商城好物',
    clearSelection: '清空选中',
    previewPage: '预览页面',
    noPreviewContent: '暂无可预览内容',
    copyPage: '复制页面',
    sharePage: '分享页面',
    moveUp: '上移',
    moveDown: '下移',
    copyComponent: '复制组件',
    actionCompleted: '操作已完成',
    memberInfoComponent: '会员信息',
    memberCodeComponent: '会员码',
    assetOverviewComponent: '资产概览',
    memberPreviewName: '会员昵称',
    memberPreviewPhone: '159****0000',
    memberPreviewNo: '用户编号 U10086001',
    memberPreviewLevel: '钻石会员',
    showMemberAvatar: '显示头像',
    showMemberNickname: '显示昵称',
    showMemberLevel: '显示会员等级',
    showMemberPhone: '显示手机号',
    showMemberNo: '显示用户编号',
    colorSettings: '颜色设置',
    primaryTextColor: '主要文字颜色',
    secondaryTextColor: '次要文字颜色',
    memberLevelBackgroundColor: '等级背景色',
    memberLevelTextColor: '等级文字颜色',
    memberCodeRefreshHint: '{seconds} 秒后自动刷新会员码',
    memberCodeSettings: '会员码设置',
    memberCodeAreaHeight: '会员码区域高度',
    memberCodeSize: '二维码大小',
    codeHorizontalPosition: '二维码水平位置',
    codeVerticalPosition: '二维码垂直位置',
    codePositionHint: '二维码和边框图片的高度最大不超过会员码区域高度',
    borderImage: '边框图片',
    borderImageWidth: '边框宽度',
    borderImageHeight: '边框高度',
    horizontalPosition: '水平位置',
    verticalPosition: '垂直位置',
    borderImagePositionHint: '水平位置正值向右移动，垂直位置正值向下移动，负值反向',
    showRefreshCountdown: '显示刷新倒计时',
    refreshIntervalSeconds: '刷新时间（秒）',
    codeColor: '二维码颜色',
    accentColor: '强调色',
    hintColor: '提示文字颜色',
    assetDisplay: '资产显示',
    assetYearMonthPass: '年月票',
    assetCountPass: '计次票',
    assetEmpty: '请选择要展示的资产',
    assetAmountColor: '资产金额颜色',
    assetLabelColor: '资产名称颜色',
    orderCenterComponent: '订单中心',
    myOrders: '我的订单',
    allOrders: '全部订单',
    pendingPayment: '待付款',
    pendingArrival: '待到店',
    pendingReceipt: '待收货',
    completedOrders: '已完成',
    afterSalesRefund: '售后/退款',
    orderCenterBackgroundSettings: '订单中心背景',
    orderCenterBackgroundSizeHint: '推荐尺寸：750px × 252px 或同比例图片',
    myServiceComponent: '我的服务',
    myServiceTitle: '我的服务',
    myServiceMore: '更多',
    personalProfile: '个人资料',
    myAssets: '我的资产',
    coupon: '优惠券',
    customerService: '客服中心',
    storeInfo: '门店信息',
    myServiceEmpty: '暂无可展示的服务入口',
    myServiceBackgroundSettings: '我的服务背景',
    myServiceBackgroundSizeHint: '推荐尺寸：750px × 308px 或同比例图片',
    searchComponent: '搜索组件',
    searchBox: '搜索框',
    searchBoxBackgroundColor: '搜索框背景色',
    borderBackgroundColor: '边框背景',
    searchText: '搜索框文字',
    placeholderText: '提示文字',
    searchIconColor: '搜索图标颜色',
    searchButtonTextColor: '搜索字色',
    searchButton: '搜索',
    searchPlaceholder: '请输入关键字',
    searchIconImage: '搜索框图片',
    showImage: '显示图片',
    searchIconSizeHint: '推荐尺寸：30px × 30px 或同比例图片',
    searchBorderRadius: '搜索框圆角',
    rightImage: '右侧图片',
    rightImageSizeHint: '建议宽高为 40px × 40px',
    imageWidth: '图片宽度',
    imageHeight: '图片高度',
    borderColor: '边框颜色',
    categoryComponent: '商品分类',
    mallCategoryComponent: '商城分类',
    mobilePhone: '手机',
    computer: '电脑',
    tablet: '平板',
    television: '电视',
    wearable: '穿戴',
    headphones: '耳机',
    shoppingCartDisplay: '购物车显示',
    defaultProductName: '精选品质商品',
    selectedItems: '已选 {count} 件',
    totalAmount: '合计：',
    checkout: '去结算',
    buy: '购买',
    firstTitle: '首标题',
    pageJumpConfig: '页面跳转配置',
    layoutSettings: '布局设置',
    offset: '偏移',
    gridSpan: '栅格跨度',
    navigationComponent: '导航按钮',
    carouselComponent: '轮播图',
    productCarouselComponent: '商品轮播图',
    productCarouselHint: '提示：自动加载商品详情的图片显示；商品详情如果有视频，第一张将自动显示为视频。',
    noticeComponent: '通知公告',
    componentLibrary: '组件库',
    componentManager: '组件管理',
    componentSettings: '组件设置',
    componentLimit: '最多添加 99 个组件',
    itemsPerRow: '每行个数',
    recommendedSize: '推荐尺寸',
    navigationSizeHint: '120px × 120px 或同比例尺寸',
    navigationImage: '图片',
    navigationName: '名称',
    navigationPage: '页面',
    navigationLinkPlaceholder: '请输入页面路径或自定义链接',
    navigationNamePlaceholder: '请输入导航名称',
    defaultNavigationName: '标题文字',
    addNavigationButton: '新增导航按钮',
    navigationLimitHint: '最多添加 10 个导航按钮',
    carouselImages: '轮播图片',
    addCarouselImage: '添加轮播图',
    carouselEmpty: '暂无轮播图片',
    carouselLimitHint: '最多选择 5 张图片',
    carouselRecommendedSize: '推荐尺寸：750px × {height}px',
    selectPage: '请选择页面',
    autoplay: '自动播放',
    switchInterval: '切换间隔',
    intervalMilliseconds: '切换间隔（毫秒）',
    noticeList: '通告内容',
    noticeBadge: '通告',
    noticeEmpty: '暂无通告',
    noticeLimitHint: '最多添加 5 条，每条最多 25 个字符',
    addNotice: '新增通告',
    noticeTextPlaceholder: '请输入通告内容',
    pageType: '页面类型',
    pageTypePlaceholder: '请输入页面类型',
    pageCode: '页面编码',
    pageCodePlaceholder: '请输入页面编码',
    noticeImageSizeHint: '建议使用清晰的小尺寸图片',
    defaultNotice: '欢迎光临，精彩活动正在进行',
    hotSaleComponent: '热选爆款',
    seckillComponent: '秒杀组件',
    tabBarComponent: 'Tab栏组件',
    componentContent: '组件内容',
    basicStyle: '基础样式',
    styleOptimization: '样式优化',
    componentName: '组件名称',
    staticComponentContentHint: '该组件暂无可编辑内容，可在其他页签调整展示样式。',
    backgroundSettings: '组件基础样式',
    backgroundColor: '背景色',
    optimizedBackgroundColor: '优化背景颜色',
    padding: '组件内边距（padding）',
    margin: '组件外边距（margin）',
    borderRadius: '圆角',
    top: '上',
    bottom: '下',
    left: '左',
    right: '右',
    topLeft: '左上',
    topRight: '右上',
    bottomLeft: '左下',
    bottomRight: '右下',
    displaySettings: '显示设置',
    showText: '显示文字',
    textColor: '文字颜色',
    backgroundImage: '背景图片',
    imageUrl: '图片地址',
    enterImageUrl: '请输入背景图片 URL',
    videoComponent: '视频',
    videoEmpty: '请配置视频地址',
    videoUrl: '视频地址',
    enterVideoUrl: '请输入视频 URL',
    videoPosterUrl: '视频封面地址',
    enterVideoPosterUrl: '请输入视频封面 URL',
    videoControls: '显示播放控件',
    videoAutoplay: '自动播放',
    videoLoop: '循环播放',
    videoMuted: '静音播放',
    multiImageComponent: '多图组件',
    multiImageStyle: '样式风格',
    styleOne: '样式一',
    styleTwo: '样式二',
    styleThree: '样式三',
    displayHeight: '显示高度',
    imageGap: '图片间隔',
    multiImageList: '图片',
    multiImageEmpty: '暂无图片',
    multiImageFixedSlotsHint: '当前样式固定配置 {count} 张图片',
    dragToSort: '拖拽排序',
    multiImageRecommendedSize: '推荐尺寸：{size}',
    selectImage: '请选择图片',
    singleImageComponent: '单图组件',
    singleImageEmpty: '请选择单张图片',
    singleImageRecommendedSize: '推荐尺寸：{size} 或同比例尺寸',
    imageHotspotComponent: '图片热图',
    imageHotspotEmpty: '请先选择热图底图',
    editHotspots: '编辑热区',
    hotspotList: '热区列表',
    addHotspot: '添加热区',
    hotspotEmpty: '暂无热区',
    hotspotHint: '拖动热区调整位置，拖动右下角控制点调整大小',
    hotspotArea: '热区 {index}',
    hotspotImage: '热图底图',
    deleteHotspot: '删除热区',
    titleTextComponent: '标题文字',
    defaultTitleText: '标题文字',
    titleTextPlaceholder: '请输入文本内容',
    imageHeightPlaceholder: '图片高度',
    textMarginPlaceholder: '文字边距',
    fontWeightPlaceholder: '字体加粗，输入100-900',
    jumpLink: '跳转链接',
    background: '背景',
    textStyle: '文字样式',
    titleText: '标题文字',
    textAlignment: '文字对齐',
    alignLeft: '左对齐',
    alignCenter: '居中对齐',
    alignRight: '右对齐',
    leftMargin: '左边距',
    rightMargin: '右边距',
    verticalMargin: '上下边距',
    fontSize: '字号',
    fontWeight: '字重',
    lineHeight: '文字行高/组件高度',
    backgroundImageRecommendedSize: '推荐尺寸：750px × {height}px 或同比例尺寸',
    enableBorderRadius: '启用圆角',
    productRecommendationComponent: '商品推荐',
    productInfoComponent: '商品信息',
    productDetailTitleComponent: '商品详情标题',
    productSpecificationComponent: '规格选择',
    productPurchaseComponent: '购买操作',
    productInfoContent: '商品信息 · 组件内容',
    showProductDescription: '展示商品简介',
    productTitleColor: '商品标题颜色',
    specification: '规格',
    selectSpecificationHint: '请选择商品规格',
    quantity: '数量',
    showPurchaseQuantity: '展示购买数量',
    labelColor: '标签颜色',
    contentColor: '内容颜色',
    showCustomerService: '展示客服入口',
    showShoppingCart: '展示购物车入口',
    showAddToCart: '展示加入购物车',
    addToCart: '加入购物车',
    buyNow: '立即购买',
    buyNowBackground: '立即购买背景色',
    buyNowTextColor: '立即购买文字色',
    addToCartBackground: '加入购物车背景色',
    addToCartTextColor: '加入购物车文字色',
    applicableScope: '适用范围',
    allProducts: '适用于所有商品',
    productInfoScopeDescription: '当前模板统一作用于所有商品详情；小程序根据用户点击的商品加载对应数据，不在装修端绑定某个商品。',
    displayContent: '展示内容',
    showOriginalPrice: '展示商品划线价',
    showSoldQuantity: '展示已售数量',
    showStock: '展示库存',
    systemProductData: '系统商品数据',
    productInfoDataSourceDescription: '商品名称、销售价格、商品划线价、已售数量和库存均读取当前商品实时数据，不支持手工改写。',
    productPreviewName: '单人全日畅玩票',
    productPreviewDescription: '当日不限次数畅玩运动项目，适合亲子家庭到店使用',
    stockCount: '库存 {count}',
    defaultRecommendationTitle: '专属推荐',
    dataSource: '数据来源',
    defaultLoad: '默认加载',
    specifiedCategory: '指定分类',
    specifiedBrand: '指定品牌',
    specifiedProducts: '指定商品',
    selectProducts: '选择商品',
    productImage: '商品图片',
    productName: '商品名称',
    productCode: '商品编码',
    mnemonicCode: '助记码',
    productType: '商品类型',
    productSubType: '商品子类型',
    backendCategory: '后台分类',
    frontendCategory: '前台分类',
    storefrontCategory: '前台分类',
    countTicket: '计次票',
    timeTicket: '年月票',
    selectCategory: '请选择前台分类',
    selectBrand: '选择品牌',
    selectedBrandId: '已选品牌 ID：{id}',
    selectedProductCount: '已选 {count} 件商品',
    productQuantity: '商品数量',
    productSort: '商品排序',
    sortDescending: '排序倒序',
    lowestPriceFirst: '最低价优先',
    newestFirst: '最新创建优先',
    defaultSort: '默认',
    salesSort: '销量',
    priceSort: '价格',
    newProductSort: '新品',
    arrangement: '排列方式',
    twoColumns: '两个',
    threeColumns: '三个',
    singleRow: '单行',
    carouselDisplay: '轮播显示',
    display: '显示',
    hide: '隐藏',
    componentBackground: '组件背景',
    productBackground: '商品背景',
    titleSettings: '标题设置',
    titleDisplay: '标题显示',
    title: '标题',
    titleColor: '标题颜色',
    titleIcon: '标题图标',
    titleIconPlaceholder: '请输入图标类名',
    productCardSettings: '商品样式',
    productRadius: '商品圆角',
    productImageRadius: '商品图圆角',
    productNameColor: '商品名称色',
    productTextSize: '商品文字大小',
    productDescriptionColor: '商品介绍色',
    tagSettings: '标签样式',
    ticketTypeTag: '票类型标签',
    tagBackground: '背景',
    tagRadius: '圆角',
    tagTextColor: '文字',
    purchaseSettings: '购买与价格',
    buyButton: '购买按钮',
    buyBackground: '购买背景',
    buyRadius: '购买圆角',
    buyTextColor: '购买文字',
    priceColor: '价格颜色',
    priceSize: '价格大小',
    salesTextColor: '已售文字',
    soldCount: '已售 {count}',
    stock999Plus: '库存999+',
    noRecommendedProducts: '暂无推荐商品',
    productSelectionComponent: '商品甄选',
    defaultProductSelectionTitle: '商品甄选',
    more: '更多',
    noSelectedProducts: '暂无甄选商品',
    titleIconTextPlaceholder: '请输入标题图标文字',
    titleImageDisplay: '标题图片显示',
    titleImagePath: '标题图片原始路径',
    enterOriginalImagePath: '请输入后端返回的图片原始路径',
    moreDisplay: '更多显示',
    moreTextColor: '更多文字颜色',
    backgroundImagePath: '背景图片原始路径',
    pageSpacing: '页面间距',
    enableCustomStyles: '启用协议样式',
    productImageBackground: '商图背景',
    productNameDisplay: '商品名称显示',
    priceDisplay: '价格显示',
    priceTagBackground: '价格标签',
    priceTagImage: '价格标签图片',
    priceTagImageSizeHint: '推荐尺寸：120px × 36px 或同比例尺寸',
    priceTagRadius: '标签圆角',
    priceTopMargin: '标签上边距',
    productSelectionBackgroundSizeHint: '推荐尺寸：750px × 382px 或同比例尺寸',
    cornerRadiusSettings: '圆角',
    selectLink: '选择跳转页面',
    selectLinkPlaceholder: '请选择跳转页面',
    mallPageDirectory: '商城页面',
    decorationPageDirectory: '装修页面',
    noLinkOptions: '暂无可选页面',
    linkGroupNames: {
      BASIC_PAGE: '基础页面',
      CUSTOM_PAGE: '自定义页面',
    },
    basicPageNames: {
      HOME: '首页',
      PROFILE: '个人中心',
      CATEGORY: '商品分类',
      MEMBER_CODE: '会员码',
      PRODUCT_DETAIL: '商品详情',
      CART: '购物车',
    },
  },
};
